export const UI_ID = {
  SWAP_FROM_INPUT_CONTAINER_ID: 'rango-swap-from-input-container',
  SWAP_TO_INPUT_CONTAINER_ID: 'rango-swap-to-input-container',
  SWAP_FROM_CHAIN_IMAGE_ID: 'rango-swap-from-chain-image',
  SWAP_TO_CHAIN_IMAGE_ID: 'rango-swap-to-chain-image',
};
